// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"fmh-terms-and-conditions_termsAndConditions__3HNgF","downloadPromptLink":"fmh-terms-and-conditions_downloadPromptLink__ulsJ4"};